var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('header-mobile',{staticClass:"desktop-hide"}),_c('header-desktop',{staticClass:"mobile-hide"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }